export default __webpack_public_path__ + "static/media/KOD0048-min.32acb00b.webp";